/*
 *		Copyright (c) 2011-2021 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('accessWebClient')
    .factory('loadEmailSuggestions', ['$q', '$http', 'apiAddressFilter', function ($q, $http, apiAddressFilter) {
        const EMAIL_SUGGESTIONS_URL = apiAddressFilter('/email_suggestions');

        return function (query) {
            return query.length > 0 ? $http.get(EMAIL_SUGGESTIONS_URL, {
                params: {
                    query: query
                },
            }) : $q.resolve([]);
        };
    }]);
